module.exports = __webpack_public_path__ + "static/media/HCMM751.1e8ace34.jpg";